import React from 'react';
import { connectSortBy } from 'react-instantsearch-dom';

interface Item {
  label: string,
  value: string,
  sortKey?: string,
  wrapperClass?: string,
}

interface Props {
  defaultRefinement: string,
  currentRefinement: string,
  selected?: string,
  wrapperClass?: string,
  items: Array<Item>,
  refine: (value: string) => void,
  onChangeCallback?: (
    value: string,
  ) => void,
}

const CustomSortBy: React.FC<Props> = ({
  items,
  refine,
  wrapperClass = '',
  onChangeCallback,
  currentRefinement,
  selected,
  defaultRefinement,
}) => {
  return (
    <div className={`ais-SortBy ${wrapperClass}`}>
      <select
        className="ais-SortBy-select"
        value={selected || currentRefinement}
        onChange={(e) => {
          if (onChangeCallback) {
            onChangeCallback(e.target.value);
          } else {
            refine(e.target.value);
          }
        }}
      >
        {
          items.map((item: Item) => (
            <option
              key={item.value}
              className="ais-SortBy-option"
              value={item.value}
            >
              {item.label}
            </option>
          ))
        }
      </select>
    </div>
  );
};

export default connectSortBy(CustomSortBy);
